export const changeCropParameterFileReducer = (state = null, action) => {
  switch (action.type) {
    case "CHANGE_CROP_PARAMETER_FILE":
      return action.payload.cropParameterFile;
    default:
      return state;
  }
};
